import api from './api';
class NotificationTemplatesService {
    // Listar todos os templates
    async getAll() {
        const response = await api.get('/notification-templates');
        return response.data.data || response.data || [];
    }
    // Buscar template por ID
    async getById(id) {
        const response = await api.get(`/notification-templates/${id}`);
        return response.data.data || response.data;
    }
    // Criar novo template
    async create(data) {
        const response = await api.post('/notification-templates', data);
        return response.data.data || response.data;
    }
    // Atualizar template
    async update(id, data) {
        const response = await api.put(`/notification-templates/${id}`, data);
        return response.data.data || response.data;
    }
    // Deletar template
    async delete(id) {
        await api.delete(`/notification-templates/${id}`);
    }
    // Buscar templates por estado
    async getByEstado(estadoId) {
        const response = await api.get(`/notification-templates/by-estado/${estadoId}`);
        return response.data.data || response.data || [];
    }
    // Enviar notificação manual
    async sendManual(templateId, ordemServicoId, canal) {
        await api.post(`/notification-templates/${templateId}/send`, {
            ordemServicoId,
            canal
        });
    }
}
export default new NotificationTemplatesService();
